import React, {useEffect} from "react";
import {ActionResult} from "../../model/ActionResult";
import {CouponDelivery} from '../../model/CouponDelivery';
import {Container} from 'react-bootstrap';
import Parser from "html-react-parser";

const CompleteHtml = (props: any) => {
    let title = "배달접수 완료";
    const act: ActionResult = props.act;
    const isReject = props.flag === 'reject';
    let content = "고객분께 배달 접수건에 대해 <br />전달하였습니다.";
    let img = '/img/Group02.png';
    if (isReject) {
        title = "배달불가";
        content = "고객분께 사정이 여의치 않아 배달이 <br>불가하다고 전달하였습니다.";
        img = '/img/Group04.png';
    }
    console.log(`act=${JSON.stringify(act)}`);
    if (act.result === false) {
        content = `오류 : ${act.errorMsg}`;
    }
    let entity: CouponDelivery = act.data ?? {};

    return (
        <div className="bloc l-bloc" id="bloc-0">
            <Container className="bloc-sm">
                <div className="row">
                    <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
                        <div className="card"><img src="/img/lazyload-ph.png" data-src={img}
                                                   className="img-fluid mx-auto d-block img-style lazyload "
                                                   alt="placeholder user"/>
                            <div className="card-body">
                                <h3 className="mg-md text-center title3">{title}</h3>
                                <h6 className="mg-md text-center title6 text-lg-center">{Parser(content)}</h6>
                                <h5 className="mg-md subtitle">주문정보</h5>
                                <ul className="list-unstyled">
                                    <li className="delivery_info">
                                        <p className="delivery_text">쿠폰: {entity.couponNm}</p>
                                    </li>
                                    <li className="delivery_info">
                                        <p className="delivery_text">접수일시 : {entity.createDate}</p>
                                    </li>
                                    <li className="delivery_info">
                                        <p className="delivery_text">주문자명 : {entity.name}</p>
                                    </li>
                                    <li className="delivery_info">
                                        <p className="delivery_text">연락처 : {entity.tel}</p>
                                    </li>
                                    <li className="delivery_info">
                                        <p className="delivery_text">주소 : {entity.address}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};
export default CompleteHtml;
